import { Check } from "lucide-react";

const plans = [
  {
    name: "Audit",
    blurb: "Start here",
    price: "Free",
    unit: "No-obligation review",
    cta: "Request audit",
    features: [
      "Full LinkedIn profile teardown",
      "ICP & positioning recommendations",
      "Sample DM script for your niche",
      "30-min walkthrough call",
    ],
    highlight: false,
  },
  {
    name: "Growth",
    blurb: "Our most popular plan",
    price: "$699",
    unit: "/ month",
    cta: "Start the system",
    features: [
      "Full LinkedIn profile overhaul",
      "Sales Navigator setup + ICP targeting",
      "Daily personalized DMs in your voice",
      "2 LinkedIn posts written for you / week",
      "Qualified calls dropped on your calendar",
      "No-show replacement guarantee",
    ],
    highlight: true,
  },
  {
    name: "Scale",
    blurb: "For multi-partner firms",
    price: "Custom",
    unit: "Volume pricing",
    cta: "Talk to founders",
    features: [
      "Multiple LinkedIn accounts managed",
      "Industry-segmented messaging (trades, SaaS, etc.)",
      "Weekly long-form content + video scripts",
      "CRM + Slack integration",
      "Dedicated success manager",
    ],
    highlight: false,
  },
];

export default function Pricing() {
  return (
    <section
      id="pricing"
      data-testid="pricing-section"
      className="py-20 lg:py-28 border-b border-[#E4E4E7]"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="mb-14 max-w-3xl">
          <p className="font-mono text-xs font-bold uppercase tracking-[0.25em] text-[#1F4DA0] mb-4">
            Pricing
          </p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.05]">
            Simple plans. Outsized LinkedIn ROI.
          </h2>
          <p className="mt-5 text-base text-[#52525B] max-w-xl">
            Start with a free profile audit. If we're a fit, you only continue when you've seen the system work.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-px bg-[#09090B] border border-[#09090B]">
          {plans.map((p, i) => (
            <div
              key={p.name}
              data-testid={`pricing-card-${p.name.toLowerCase()}`}
              className={`p-8 lg:p-10 relative flex flex-col ${
                p.highlight ? "bg-[#09090B] text-white" : "bg-white text-[#09090B]"
              }`}
            >
              {p.highlight && (
                <span className="absolute top-0 right-0 bg-[#3FA742] text-white font-mono text-[10px] uppercase tracking-widest px-3 py-1.5">
                  Most picked
                </span>
              )}
              <p className="font-mono text-[10px] uppercase tracking-widest opacity-70">
                {p.blurb}
              </p>
              <h3 className="font-display font-extrabold text-3xl tracking-tight mt-2">{p.name}</h3>
              <div className="mt-6 flex items-baseline gap-2">
                <span className="font-display font-black text-5xl tracking-tighter">{p.price}</span>
                <span className={`text-sm ${p.highlight ? "text-white/60" : "text-[#52525B]"}`}>{p.unit}</span>
              </div>
              <ul className="mt-8 space-y-3 flex-1">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-3 text-sm">
                    <Check size={16} className={`mt-0.5 shrink-0 ${p.highlight ? "text-[#3FA742]" : "text-[#1F4DA0]"}`} strokeWidth={2.5} />
                    <span className={p.highlight ? "text-white/85" : "text-[#09090B]"}>{f}</span>
                  </li>
                ))}
              </ul>
              <a
                href="#contact"
                data-testid={`pricing-cta-${p.name.toLowerCase()}`}
                className={`mt-10 inline-flex items-center justify-center font-bold px-6 py-4 transition-colors ${
                  p.highlight
                    ? "bg-[#3FA742] text-white hover:bg-white hover:text-[#09090B]"
                    : "bg-[#09090B] text-white hover:bg-[#1F4DA0]"
                }`}
              >
                {p.cta} →
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
